import { render, staticRenderFns } from "./ui-treeview.vue?vue&type=template&id=df767b98&scoped=true&"
import script from "./ui-treeview.vue?vue&type=script&lang=ts&"
export * from "./ui-treeview.vue?vue&type=script&lang=ts&"
import style0 from "./ui-treeview.vue?vue&type=style&index=0&id=df767b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df767b98",
  null
  
)

export default component.exports